import styled from 'styled-components';

const Watermark = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  font-size: 10vmin;
  font-weight: bold;
  height: 100%;
  justify-content: center;
  opacity: 0.1;
  pointer-events: none;
  position: fixed;
  top: 0;
  transform: rotateZ(-45deg);
  user-select: none;
  width: 100%;
  z-index: 9999;
`;

export default Watermark;



// WEBPACK FOOTER //
// ./src/app/components/Watermark/index.jsx